import React, { FC } from "react";
import Styles from "./index.scss";

type Props = { title?: string; category?: string; searchCategory?: string };

export const SearchFormBox: FC<Props> = ({ category = "Nieuws", searchCategory = "nieuws" }) => (
    <div className="search-form-box">
        <style jsx>{Styles}</style>

        <form action="/blog/search">
            <label htmlFor="query">
                <input id="query" name="query" type="text" placeholder={`Zoek in ${category}`} />
                <input id="category" name="category" type="hidden" value={searchCategory} />
            </label>
        </form>
    </div>
);
